import { render } from "./LoanConfigIdCopy.vue?vue&type=template&id=2a0a68cc&scoped=true"
import script from "./LoanConfigIdCopy.vue?vue&type=script&lang=js"
export * from "./LoanConfigIdCopy.vue?vue&type=script&lang=js"

import "./LoanConfigIdCopy.vue?vue&type=style&index=0&id=2a0a68cc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0a68cc"]])

export default __exports__